"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbIosBiocatch = exports.MbAndroidBiocatch = exports.MbBiocatch = exports.Biocatch = exports.BData = exports.MbBData = exports.MbIosBData = exports.MbAndroidBData = void 0;
const init_1 = require("../../mobileConnector/init");
const features_1 = require("../../features");
class MbAndroidBData extends features_1.MbAndroidBData {
    constructor(url) {
        super(url, init_1.getMobileConnector);
    }
}
exports.MbAndroidBData = MbAndroidBData;
class MbIosBData extends features_1.MbIosBData {
    constructor(baseUrl, slaveUrl) {
        super(baseUrl, slaveUrl, init_1.getMobileConnector);
    }
}
exports.MbIosBData = MbIosBData;
class MbBData extends features_1.MbBData {
    constructor() {
        super(init_1.getMobileConnector);
    }
}
exports.MbBData = MbBData;
exports.BData = new features_1.MbBData(init_1.getMobileConnector);
/** @deprecated please use BData instead */
exports.Biocatch = exports.BData;
/** @deprecated please use MbBData instead */
exports.MbBiocatch = MbBData;
/** @deprecated please use MbAndroidBData instead */
exports.MbAndroidBiocatch = MbAndroidBData;
/** @deprecated please use MbIosBData instead */
exports.MbIosBiocatch = MbIosBData;
//# sourceMappingURL=index.js.map